import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  InputLabel,
} from '@mui/material';
import { RootContext } from 'components/RootContainer';
import { FC, ReactNode, useContext } from 'react';
import { useQuery } from 'react-query';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 10;

export const RateField: FC<{
  value: number[] | null;
  onChange: (value: string[] | null) => void;
  error?: ReactNode;
}> = ({ value, onChange, error }) => {
  const {
    HotelApi: {
      revenueManagement: { rate: RateService },
    },
  } = useContext(RootContext);

  const { isLoading, data } = useQuery({
    queryKey: ['get-rates'],
    queryFn: () => {
      return RateService.rate.getAll({
        limit: 500,
      });
    },
  });

  const handleChange = (rateId: string) => {
    const currentValues = value?.map(String) ?? [];
    const newValues = currentValues.includes(rateId)
      ? currentValues.filter(id => id !== rateId)
      : [...currentValues, rateId];

    onChange(newValues.length > 0 ? newValues : null);
  };

  if (isLoading) {
    return <>...</>;
  }

  return (
    <FormControl
      variant="standard"
      fullWidth
      sx={{
        boxShadow: 'inset 0 -1px 0 0 #d2d7de',
        pb: 2,
      }}
    >
      <InputLabel shrink>Rate</InputLabel>
      <Box
        sx={{
          mt: 3,
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          overflow: 'auto',
        }}
      >
        <FormGroup
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {(data || []).map(item => (
            <FormControlLabel
              key={item.id}
              control={
                <Checkbox
                  checked={value?.map(String).includes(String(item.id)) ?? false}
                  onChange={() => handleChange(String(item.id))}
                  sx={{
                    mr: 1,
                  }}
                />
              }
              label={item.name}
              sx={{ py: 0.5, pl: 1.5 }}
            />
          ))}
        </FormGroup>
      </Box>
      {Boolean(error) && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );
};
